module.exports = __webpack_public_path__ + "img/tips_2.d10c2a5f.png";